import axios from 'src/utils/axios';

export const GET_NOTIFICATIONS = '@notifications/get-notifications';

export function getNotifications(_userId) {
  
  const request = axios.get('/api/notification/' + _userId);
  
  return (dispatch) => {
    request.then((response) => 
      dispatch({
        type: GET_NOTIFICATIONS,
        payload: response.data
      })
    ); 
    
  };
}
